import logo from "../images/login-images/logo.svg";
import sideImage1 from "../images/login-images/login-slider.svg";
import cm from "../images/role-selection-images/cm.svg";
import fl from "../images/role-selection-images/fl.svg";
import ml from "../images/role-selection-images/ml.svg";
import pa from "../images/role-selection-images/pa.svg";
import pfa from "../images/role-selection-images/pfa.svg";
import sm from "../images/role-selection-images/site-manager.svg";
import samp_mod from "../images/dummy/overall_plot.png";
export const LOCAL_IMAGE = {
  LOGO: logo,
  SLIDER_IMG1: sideImage1,
  CM_IMG: cm,
  FL_IMG: fl,
  ML_IMG: ml,
  PA_IMG: pa,
  PFA_IMG: pfa,
  SITE_MANAGER_IMG: sm,
  SAMPLE_MODEL: samp_mod,
};
